<ng-container [formGroup]="form()">
  <ng-container formGroupName="recurrence">
    @if (isMonthly()) {
      <div>
        <lib-select
          [inputFormControlName]="'by'"
          id="schedule-recurrence-by"
          name="by"
          [label]="'event_monthly_months_label' | transloco"
          [placeholder]="'event_monthly_by_placeholder' | transloco"
          [options]="recurrenceByOptions()"
          [required]="true"
          [selectedKeyValue]="'value'"
          [selectedKeyName]="'label'" />
        <lib-validation-message
          [lang]="'current_lang' | transloco"
          [control]="'by'" />
      </div>
    }

    @if (showInterval()) {
      <div>
        <lib-input
          [inputFormControlName]="'interval'"
          id="schedule-recurrence-interval"
          type="number"
          name="interval"
          [label]="'schedule_workflow_form_repeat_every_label' | transloco"
          [placeholder]="'1'"
          [required]="true"
          [min]="1"
          [endIconTemplate]="repeatEveryUnitTemplate"
          endIconClass="!size-auto" />
        <ng-template #repeatEveryUnitTemplate>
          @if (repeatEveryUnit()) {
            <p class="text-xs text-neutral-500 mt-x-sm">
              {{ repeatEveryUnit() }}
            </p>
          }
        </ng-template>
        <lib-validation-message
          [lang]="'current_lang' | transloco"
          [control]="'interval'" />
      </div>
    }

    @if (isMonthlyByMonths()) {
      <div>
        <lib-multi-select
          [inputFormControlName]="'months'"
          id="schedule-recurrence-months"
          name="months"
          [label]="'event_monthly_months_select_label' | transloco"
          [placeholder]="'event_monthly_months_select_placeholder' | transloco"
          [options]="translatedMonthOptions()"
          [required]="true"
          [selectedKeyValue]="'value'"
          [selectedKeyName]="'label'" />
        <lib-validation-message
          [lang]="'current_lang' | transloco"
          [control]="'months'" />
      </div>
    }

    @if (isWeekly()) {
      <div>
        <lib-multi-select
          [inputFormControlName]="'days_of_week'"
          id="schedule-recurrence-days"
          name="days_of_week"
          [label]="'schedule_workflow_form_days_label' | transloco"
          [placeholder]="'schedule_workflow_form_days_placeholder' | transloco"
          [options]="translatedWeekDayOptions()"
          [required]="true"
          [selectedKeyValue]="'value'"
          [selectedKeyName]="'label'" />
        <lib-validation-message
          [lang]="'current_lang' | transloco"
          [control]="'days_of_week'" />
      </div>
    }

    @if (isMonthly() || isYearly()) {
      <div>
        <lib-select
          [inputFormControlName]="'repeatOnByDayOfMonth'"
          id="schedule-recurrence-repeat-on"
          name="repeatOnByDayOfMonth"
          [label]="'schedule_workflow_form_repeat_on_label' | transloco"
          [placeholder]="
            'schedule_workflow_form_repeat_on_placeholder' | transloco
          "
          [options]="repeatOnOptions()"
          [required]="true"
          [selectedKeyValue]="'value'"
          [selectedKeyName]="'label'" />
        <lib-validation-message
          [lang]="'current_lang' | transloco"
          [control]="'repeatOnByDayOfMonth'" />
      </div>
    }
  </ng-container>
</ng-container>
